import { memo, useRef } from 'react'
import styled from 'styled-components'
import { useField } from 'formik'

import Error, { ErrorText } from '@/components/form/error'
import InputMask from '@/components/react-input-mask'

import Input from './input'

const unmaskValue = (input = '') => input.replace(/( |-|\(|\)|\/)/g, '')

const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

// We define a default mask
// in the case of credit cards
// where we initially don't know
// the mask.  Otherwise onChange
// does not get called.
const defaultMask = '9'.repeat(40)

const renderError = (hasError, meta, name, customError) => {
  if (!hasError) return null
  return meta.error ? (
    <Error name={name} />
  ) : (
    <ErrorText role="alert">{customError}</ErrorText>
  )
}

const identity = v => v

const MaskedInput = ({
  name,
  format,
  customError,
  onBlur,
  disabled,
  errorLocation = 'bottom',
  beforeMaskedValueChange,
  children,
  onFocus,
  hideError = false,
  encode = identity,
  decode = identity,
  ...rest
}) => {
  const fieldRef = useRef()
  const [field, meta, helpers] = useField(name)
  const hasError = (!!meta.error && meta.touched) || customError
  const handleChange = e => {
    const newValue = encode(unmaskValue(e.target.value))
    helpers.setValue(newValue)
  }
  const { name: formName, onBlur: formOnBlur } = field
  const mask = format || defaultMask

  return (
    <>
      {errorLocation === 'top' &&
        !hideError &&
        renderError(hasError, meta, name, customError)}
      <Wrapper>
        <InputMask
          maskChar={null}
          mask={mask}
          value={decode(field.value)}
          onChange={handleChange}
          onBlur={e => {
            if (typeof onBlur === 'function') onBlur()
            formOnBlur(e)
          }}
          onFocus={onFocus}
          disabled={disabled}
          beforeMaskedValueChange={beforeMaskedValueChange}
        >
          {props => (
            <Input
              name={formName}
              ref={fieldRef}
              {...rest}
              hasError={hasError}
              {...props}
            />
          )}
        </InputMask>
        {children}
      </Wrapper>
      {errorLocation === 'bottom' &&
        !hideError &&
        renderError(hasError, meta, name, customError)}
    </>
  )
}

export default memo(MaskedInput)
